import type { $Fetch } from 'ofetch';
import type { UserGateway, ListUsersParams } from '@/application/port/out/UserGateway';
import type { ManagedUser, CreateUserCommand, UpdateUserCommand } from '@/domain/model/ManagedUser';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/users';

/** HTTP gateway do gerenciamento de usuários. Authority BE: `identity:user:*`. */
export class HttpUserGateway implements UserGateway {
  constructor(private readonly client: $Fetch) {}

  async list(params: ListUsersParams): Promise<Page<ManagedUser>> {
    const res = await this.client<ApiResponse<Page<ManagedUser>>>(
      ROOT, { method: 'GET', params: { page: params.page, size: params.size } });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: CreateUserCommand): Promise<ManagedUser> {
    const res = await this.client<ApiResponse<ManagedUser>>(ROOT, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpdateUserCommand): Promise<ManagedUser> {
    const res = await this.client<ApiResponse<ManagedUser>>(
      `${ROOT}/${encodeURIComponent(id)}`, { method: 'PATCH', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async deactivate(id: string): Promise<void> {
    // BE 204 No Content — sem envelope, não chamar assertApiSuccess.
    await this.client<void>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }

  async block(id: string): Promise<void> {
    await this.client<void>(`${ROOT}/${encodeURIComponent(id)}/block`, { method: 'PUT' });
  }

  async unblock(id: string): Promise<void> {
    await this.client<void>(`${ROOT}/${encodeURIComponent(id)}/unblock`, { method: 'PUT' });
  }
}
